import * as React from 'react';

interface Props {}

const AEPIcon: React.FC<Props> = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <mask id="path-1-inside-1_1462_88443" fill="white">
        <path d="M11.4688 5.46887C11.4688 3.55624 9.91263 2.00012 8 2.00012C6.08737 2.00012 4.53125 3.55624 4.53125 5.46887C4.53125 6.65356 5.12845 7.70129 6.03738 8.32742C5.18869 8.62021 4.41086 9.10397 3.75735 9.75748C2.62411 10.8907 2 12.3975 2 14.0001H2.9375C2.9375 11.2087 5.20856 8.93762 8 8.93762C9.91263 8.93762 11.4688 7.3815 11.4688 5.46887ZM5.46875 5.46887C5.46875 4.07315 6.60428 2.93762 8 2.93762C9.39572 2.93762 10.5312 4.07315 10.5312 5.46887C10.5312 6.86459 9.39572 8.00012 8 8.00012C6.60428 8.00012 5.46875 6.86459 5.46875 5.46887ZM14 8.77356V11.5626H13.0625V10.4267L10.4851 13.0041L9.14926 11.6741L6.90759 13.9975L6.23294 13.3465L9.13589 10.3378L10.4836 11.6797L12.4523 9.71106H11.1875V8.77356H14Z" />
      </mask>
      <path
        d="M11.4688 5.46887C11.4688 3.55624 9.91263 2.00012 8 2.00012C6.08737 2.00012 4.53125 3.55624 4.53125 5.46887C4.53125 6.65356 5.12845 7.70129 6.03738 8.32742C5.18869 8.62021 4.41086 9.10397 3.75735 9.75748C2.62411 10.8907 2 12.3975 2 14.0001H2.9375C2.9375 11.2087 5.20856 8.93762 8 8.93762C9.91263 8.93762 11.4688 7.3815 11.4688 5.46887ZM5.46875 5.46887C5.46875 4.07315 6.60428 2.93762 8 2.93762C9.39572 2.93762 10.5312 4.07315 10.5312 5.46887C10.5312 6.86459 9.39572 8.00012 8 8.00012C6.60428 8.00012 5.46875 6.86459 5.46875 5.46887ZM14 8.77356V11.5626H13.0625V10.4267L10.4851 13.0041L9.14926 11.6741L6.90759 13.9975L6.23294 13.3465L9.13589 10.3378L10.4836 11.6797L12.4523 9.71106H11.1875V8.77356H14Z"
        fill="white"
        stroke="#187A90"
        strokeWidth="2"
        mask="url(#path-1-inside-1_1462_88443)"
      />
    </svg>
  );
};

export default AEPIcon;
